/* PosterLeFi produktside — interaktion.
   Serveren renderer den valgte variant; herfra styres billedskift, type/størrelse/
   ramme, valuta-formatering, læg-i-kurv og den mobile sticky-bar.

   Kurven: butikken har INGEN /cart-side (den redirecter til forsiden), og temaets
   cart-confirmation-popup lytter selv på /cart/add — derfor fetch + tælleropdatering
   og ALDRIG en redirect bagefter. URL'en skal bygges på routes-værdierne, fordi et
   ikke-præfikset /cart/add.js 302-redirecter og dermed laver POST om til GET. */
(function () {
  'use strict';

  /* Gem asset-URL'en mens scriptet eksekverer. Desktop-QR'en indlæser temaets
     egen QR-generator fra samme Shopify asset-mappe uden tredjepartstjenester. */
  var PLF_PDP_SCRIPT_SRC = (document.currentScript && document.currentScript.src) || '';

  var root = document.querySelector('[data-plf-pdp]');
  if (!root) return;
  var dataEl = root.querySelector('[data-plf-data]');
  if (!dataEl) return;

  var D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
  if (!D || !D.variants || !D.variants.length) return;
  if (!D.frames || !D.frames.length) return;   /* uden rammebilleder er der intet galleri at styre */

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var ADD_URL = ROOT.replace(/\/$/, '') + '/cart/add.js';
  var CART_URL = ROOT.replace(/\/$/, '') + '/cart.js';

  var $ = function (sel) { return root.querySelector(sel); };
  var els = {
    rail: $('[data-plf-rail]'), stage: $('[data-plf-stage]'), main: $('[data-plf-main]'),
    count: $('[data-plf-count]'), caption: $('[data-plf-caption]'),
    rooms: $('[data-plf-rooms]'), roomsGrid: $('[data-plf-rooms-grid]'), roomsN: $('[data-plf-rooms-n]'),
    wide: $('[data-plf-wide]'), wideGrid: $('[data-plf-wide-grid]'),
    types: $('[data-plf-types]'), sizes: $('[data-plf-sizes]'), frames: $('[data-plf-frames]'),
    frameName: $('[data-plf-frame-name]'), hint: $('[data-plf-hint]'), conv: $('[data-plf-conv]'),
    price: $('[data-plf-price]'), label: $('[data-plf-label]'), id: $('[data-plf-id]'),
    stock: $('[data-plf-stock]'), atc: $('[data-plf-atc]'),
    atcTxt: $('[data-plf-atc-txt]'), atcPrice: $('[data-plf-atc-price]'),
    form: $('[data-plf-form]'), wall: $('[data-plf-wall]'),
    sticky: $('[data-plf-sticky]'), stickyPrice: $('[data-plf-sticky-price]'),
    stickyLabel: $('[data-plf-sticky-label]'), stickyAtc: $('[data-plf-sticky-atc]'),
    guide: $('[data-plf-guide]'), guideRows: $('[data-plf-guide-rows]'),
    framePrice: $('[data-plf-frame-price]'), frameStep: $('[data-plf-frame-step]'),
    paper: $('[data-plf-paper]'),
    paperPrice: $('[data-plf-paper-price]'),
    arModal: $('[data-plf-ar-modal]'), arFrame: $('[data-plf-ar-frame]')
  };

  /* ---- prisformat: afledt af Shopifys egen streng, så valuta og tusindtalsskilletegn
         følger markedet uden at vi selv gætter på formatet ---- */
  var sample = D.money || '';
  function money(cents) {
    var v = (cents / 100);
    var m = sample.match(/[\d.,]+/);
    if (!m) return String(v);
    var num = m[0];
    var dec = /,\d{2}$/.test(num) ? ',' : (/\.\d{2}$/.test(num) ? '.' : '');
    var grp = dec === ',' ? '.' : ',';
    var s = v.toFixed(dec ? 2 : 0);
    var parts = s.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, grp);
    return sample.replace(m[0], dec ? parts.join(dec) : parts[0]);
  }

  /* ---- størrelsesparser: "50 x 70 cm", "14 x 21 cm (A5)" ---- */
  function dims(label) {
    var m = String(label).match(/(\d+)\s*[x×]\s*(\d+)/);
    return m ? { w: +m[1], h: +m[2] } : null;
  }
  function inch(n) { return (n / 2.54).toFixed(1).replace('.', ','); }
  function sizeLabel(label) {
    if (st.unit === 'cm') return label;
    var d = dims(label);
    if (!d) return label;
    var paren = label.match(/\(([^)]+)\)/);
    return inch(d.w) + ' × ' + inch(d.h) + '"' + (paren ? ' (' + paren[1] + ')' : '');
  }

  /* ---- tilstand ---- */
  var st = {
    type: null, size: null, frame: 0, view: 'frame', env: 0, unit: 'cm', paper: 'standard'
  };
  /* Rammen er IKKE forvalgt: "Læg i kurv" skal vise plakatens egen pris.
     Galleriet åbner derimod på eg natur-billedet (se OAK_VIEW nedenfor). */
  st.frame = 0;
  /* 50×70 er husets ankerformat og markeret "mest valgte" — start der, hvis det
     kan købes, ellers på den første variant der er på lager. */
  var avail = D.variants.filter(function (v) { return v.a; });
  /* ?variant=<id> i URL'en vinder — ellers 50×70 (husets ankerformat), ellers
     den første variant der kan købes. */
  var fromUrl = null;
  var qv = (location.search.match(/[?&]variant=(\d+)/) || [])[1] || (D.selected ? String(D.selected) : '');
  if (qv) {
    fromUrl = D.variants.filter(function (v) { return String(v.id) === String(qv); })[0] || null;
  }
  var anchor = avail.filter(function (v) { return /\b50\s*[x×]\s*70\b/.test(v.s); })[0];
  var first = fromUrl || anchor || avail[0] || D.variants[0];
  st.type = first.t; st.size = first.s;

  function sizesFor(type) {
    var seen = {}, out = [];
    D.variants.forEach(function (v) {
      if (v.t !== type || seen[v.s]) return;
      seen[v.s] = 1; out.push(v);
    });
    return out;
  }
  /* Lærred sælges uden ramme og uden papirvalg — de to trin skjules der. */
  function isCanvas() { return D.types.indexOf(st.type) === 1; }

  /* Rammen er en variant af produktet "frames": samme størrelse som plakaten
     + den valgte farve. Farven slås op på INDEKS, ikke navn — navnene er oversat
     pr. marked. "Uden ramme" koster 0 og lægges ikke i kurven. */
  var FRAME_COLOR_INDEX = {
    'Poster print': 0, 'Black Wood': 1, 'Blue Wood': 2, 'Grey Wood': 3, 'Green Wood': 4,
    'Teal Wood': 5, 'Lilac Wood': 6, 'Mint Wood': 7, 'Oak Dark': 8, 'Oak Nature': 9,
    'Orange Wood': 10, 'Red Wood': 11, 'Rose Wood': 12, 'White Wood': 13, 'Yellow Wood': 14
  };
  function framesForSize(size) {
    var out = [];
    for (var i = 0; i < (D.frames2 || []).length; i++) {
      if (D.frames2[i].s === size) out.push(D.frames2[i]);
    }
    return out;
  }
  function frameVariant() {
    if (isCanvas()) return null;
    var alt = D.frames[st.frame] && D.frames[st.frame].alt;
    var ci = FRAME_COLOR_INDEX[alt];
    if (ci === undefined || ci === 0) return null;
    var list = framesForSize(st.size);
    if (list.length !== D.frameColors) return null;   /* orden kan ikke stoles på */
    for (var i = 0; i < list.length; i++) {
      if (list[i].ci === ci) return list[i].a && list[i].p > 0 ? list[i] : null;
    }
    return null;
  }

  /* Premiumpapir er produktet "premium-paper-230"; niveauet slås op på
     plakatstørrelsen (samme tabel som den gamle produktside brugte). */
  function paperVariant() {
    if (isCanvas() || !D.paper || !D.paper.length) return null;
    var key = String(st.size || '').toLowerCase().replace(/×/g, 'x').replace(/\s+/g, ' ').trim();
    var lvl = D.paperLevels[key];
    if (!lvl) return null;
    for (var i = 0; i < D.paper.length; i++) {
      if (String(D.paper[i].lvl) === String(lvl)) return D.paper[i];
    }
    return null;
  }
  function total() {
    var v = current();
    var f = frameVariant();
    var p = st.paper === 'premium' ? paperVariant() : null;
    return (v ? v.p : 0) + (f ? f.p : 0) + (p ? p.p : 0);
  }

  function current() {
    return D.variants.filter(function (v) { return v.t === st.type && v.s === st.size; })[0]
        || sizesFor(st.type)[0];
  }

  /* ---- galleri: ALLE produktbilleder — 15 rammer + 6 rummiljøer = 21 ----
     Skinnen viser hver enkelt, og et klik på en ramme vælger den også i
     rammevælgeren, så billede og valg aldrig kommer i utakt. */
  /* Galleriet er en REN fremviser over alle produktets billeder:
       0            = eg natur (produktets eget førstebillede)
       1..n         = rummiljøerne
       n+1..        = de øvrige rammer + det flade motiv
     At bladre skifter ALDRIG hvad der købes — det gør kun rammevælgeren. */
  var VIEWS = (function () {
    var out = [], used = {};
    var oak = -1;
    for (var i = 0; i < D.frames.length; i++) {
      if (D.frames[i].alt === 'Oak Nature') { oak = i; break; }
    }
    var pushFrame = function (i) {
      if (i < 0 || used['f' + i]) return;
      used['f' + i] = 1;
      var f = D.frames[i];
      out.push({ kind: 'frame', fi: i, u: f.u, th: f.th, bare: f.bare,
        cap: f.bare ? D.i18n.capBare : (D.i18n.capFrame + ': ' + f.n) });
    };
    pushFrame(oak);
    D.envs.forEach(function (e, i) {
      out.push({ kind: 'env', ei: i, u: e.u, th: e.th, cap: e.n });
    });
    for (var j = 0; j < D.frames.length; j++) pushFrame(j);
    return out;
  })();
  st.view = 0;
  function frameView(fi) {
    for (var i = 0; i < VIEWS.length; i++) {
      if (VIEWS[i].kind === 'frame' && VIEWS[i].fi === fi) return i;
    }
    return 0;
  }
  function viewIndex() {
    return Math.max(0, Math.min(st.view || 0, VIEWS.length - 1));
  }
  function renderStage() {
    var idx = viewIndex();
    var v = VIEWS[idx];
    els.main.src = v.u;
    els.stage.dataset.fit = (v.kind === 'frame' && v.bare) ? 'contain' : 'cover';
    els.caption.textContent = v.cap;
    els.count.textContent = (idx + 1) + ' / ' + VIEWS.length;
    Array.prototype.forEach.call(els.rail.children, function (b, i) {
      b.setAttribute('aria-current', String(i === idx));
      if (i === idx && b.scrollIntoView) {
        b.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    });
    var z = root.querySelector('[data-plf-zoom]');
    if (z) z.href = v.u;
  }
  function showView(i) {
    st.view = i;
    renderStage();
  }
  function nav(delta) {
    showView((viewIndex() + delta + VIEWS.length) % VIEWS.length);
  }
  function buildRail() {
    els.rail.innerHTML = '';
    VIEWS.forEach(function (v, i) {
      var b = document.createElement('button');
      b.type = 'button'; b.setAttribute('role', 'tab');
      b.title = v.cap;
      b.innerHTML = '<img src="' + v.th + '" alt="" loading="lazy" width="88" height="88">';
      b.addEventListener('click', function () { showView(i); });
      els.rail.appendChild(b);
    });
  }
  function refreshRailThumb() {}

  /* ---- rum-grid + brede billeder ---- */
  function buildRooms() {
    if (!D.envs.length) return;
    els.rooms.hidden = false;
    els.roomsN.textContent = String(D.envs.length);
    els.roomsGrid.innerHTML = '';
    D.envs.forEach(function (e, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.innerHTML = '<img src="' + e.u + '" alt="' + e.n.replace(/"/g, '&quot;') + '" loading="lazy" width="600" height="450">' +
        '<i>' + e.n + '</i>';
      b.addEventListener('click', function () {
        st.view = 'env'; st.env = i; renderStage();
        els.stage.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
      els.roomsGrid.appendChild(b);
    });
    if (D.envs.length >= 2) {
      els.wide.hidden = false;
      els.wideGrid.innerHTML = D.envs.slice(0, 2).map(function (e) {
        return '<img src="' + e.u + '" alt="' + e.n.replace(/"/g, '&quot;') + '" loading="lazy" width="1400" height="1050">';
      }).join('');
    }
  }

  /* ---- vælgere ---- */
  function buildTypes() {
    els.types.innerHTML = '';
    D.types.forEach(function (tv, i) {
      if (!sizesFor(tv).length) return;
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'plf-pdp__type';
      b.dataset.plfType = tv;
      b.setAttribute('aria-pressed', String(tv === st.type));
      b.innerHTML = (i === 0
        ? '<span class="plf-pdp__type-ic"><i style="left:2px;top:0;width:36px;height:48px;background:#FFF;box-shadow:inset 0 0 0 1px #DCD2C4;clip-path:polygon(0 0,72% 0,100% 20%,100% 100%,0 100%)"></i><i style="left:27.9px;top:0;width:10.1px;height:9.6px;background:#E7E0D5;clip-path:polygon(0 0,100% 100%,0 100%)"></i></span>'
        : '<span class="plf-pdp__type-ic"><i style="left:0;top:0;width:34px;height:8px;background:#F4F1EC;box-shadow:inset 0 0 0 1px #DCD2C4;transform:skewX(-45deg);transform-origin:bottom left"></i><i style="left:34px;top:8px;width:8px;height:40px;background:#E4DDD2;box-shadow:inset 0 0 0 1px #DCD2C4;transform:skewY(-45deg);transform-origin:top left"></i><i style="left:0;top:8px;width:34px;height:40px;background:#FFF;box-shadow:inset 0 0 0 1px #DCD2C4"></i></span>')
        + '<span>' + (D.typeLabels[i] || tv) + '</span>';
      b.addEventListener('click', function () {
        if (st.type === tv) return;
        st.type = tv;
        var list = sizesFor(tv);
        var keep = list.filter(function (v) { return v.s === st.size; })[0];
        st.size = (keep || list.filter(function (v) { return v.a; })[0] || list[0]).s;
        render();
      });
      els.types.appendChild(b);
    });
  }

  function buildSizes() {
    els.sizes.innerHTML = '';
    var list = sizesFor(st.type);
    var maxH = 34;
    list.forEach(function (v) {
      var d = dims(v.s) || { w: 3, h: 4 };
      var w = Math.round(maxH * (d.w / d.h));
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'plf-pdp__size';
      b.setAttribute('aria-pressed', String(v.s === st.size));
      if (!v.a) b.disabled = true;
      b.innerHTML =
        '<span class="plf-pdp__size-thumb" style="width:' + w + 'px;height:' + maxH + 'px' +
        (D.art ? ';background-image:url(' + D.art + ')' : '') + '"></span>' +
        '<span class="plf-pdp__size-txt"><b>' + sizeLabel(v.s) + '</b><span>' + money(v.p) + '</span></span>' +
        (d.w === 50 && d.h === 70 ? '<span class="plf-pdp__pop">' + D.i18n.most + '</span>' : '');
      b.addEventListener('click', function () { if (v.a) { st.size = v.s; render(); } });
      els.sizes.appendChild(b);
    });
  }

  function buildFrames() {
    els.frames.innerHTML = '';
    D.frames.forEach(function (f, i) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'plf-pdp__frame';
      b.title = f.n; b.setAttribute('aria-label', f.n);
      b.setAttribute('aria-pressed', String(i === st.frame));
      b.style.background = f.sw;
      b.addEventListener('click', function () {
        st.frame = i;
        st.view = frameView(i);        /* vis den valgte ramme i galleriet */
        renderStage();
        Array.prototype.forEach.call(els.frames.children, function (x, j) {
          x.setAttribute('aria-pressed', String(j === i));
        });
        render();   /* rammen koster penge — totalen skal med det samme */
      });
      els.frames.appendChild(b);
    });
  }
  function syncFrameName() {
    els.frameName.textContent = D.frames[st.frame].n;
    var f = frameVariant();
    els.framePrice.textContent = f ? '  + ' + money(f.p) : '';
  }

  function buildGuide() {
    if (!els.guideRows) return;
    els.guideRows.innerHTML = '';
    sizesFor(D.types[0]).forEach(function (v, i) {
      var d = dims(v.s); if (!d) return;
      var tr = document.createElement('tr');
      tr.innerHTML = '<td>' + v.s.replace(/\s*cm\s*/, ' ') + '</td><td>' +
        inch(d.w) + '" × ' + inch(d.h) + '"</td><td>' + (D.i18n.fits[i] || '') + '</td>';
      els.guideRows.appendChild(tr);
    });
  }

  /* ---- opdatering ---- */
  function render() {
    var v = current();
    var d = dims(st.size);
    var canvas = isCanvas();
    var pv = paperVariant();

    /* papirtrin: kun for plakat, og kun hvis der findes et niveau for størrelsen */
    els.paper.hidden = canvas || !pv;
    if (els.paper.hidden && st.paper === 'premium') st.paper = 'standard';
    if (pv) els.paperPrice.textContent = '+ ' + money(pv.p);
    root.querySelectorAll('[data-plf-paper-kind]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.dataset.plfPaperKind === st.paper));
    });
    els.frameStep.hidden = canvas;

    var sum = total();
    var label = (D.typeLabels[D.types.indexOf(st.type)] || st.type) + ' · ' + sizeLabel(st.size)
      + (canvas ? '' : ' · ' + (st.paper === 'premium' ? '230 g' : '200 g'));
    els.price.textContent = money(sum);
    els.atcPrice.textContent = money(sum);
    els.stickyPrice.textContent = money(sum);
    syncFrameName();
    els.label.textContent = label;
    els.stickyLabel.textContent = label;
    els.id.value = v.id;
    els.hint.textContent = d ? (D.i18n.hints[String(d.w)] || '') : '';
    els.conv.textContent = st.unit === 'cm' ? D.i18n.convCm : D.i18n.convIn;
    var ok = !!v.a;
    els.atc.disabled = !ok;
    els.stickyAtc.disabled = !ok;
    els.atcTxt.textContent = ok ? els.atc.dataset.idle : els.atc.dataset.out;
    els.stickyAtc.textContent = ok ? els.atc.dataset.idle : els.atc.dataset.out;
    els.stock.innerHTML = ok
      ? '<span class="plf-pdp__dot"></span><b>' + D.i18n.inStock + '</b><i style="color:#CFC5B6;font-style:normal">·</i><span>' + D.i18n.delivery + '</span>'
      : '<span class="plf-pdp__dot plf-pdp__dot--out"></span><b>' + D.i18n.soldOut + '</b>';
    Array.prototype.forEach.call(els.types.children, function (b) {
      b.setAttribute('aria-pressed', String(b.dataset.plfType === st.type));
    });
    buildSizes();
    buildGuide();
  }

  /* ---- læg i kurv ---- */
  function refreshCount() {
    return fetch(CART_URL, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = String(cart.item_count);
          el.dataset.cartCount = String(cart.item_count);
          el.style.display = cart.item_count > 0 ? '' : 'none';
        });
      }).catch(function () {});
  }
  function addToCart(btn, setTxt) {
    var v = current();
    if (!v.a) return;
    var items = [{ id: v.id, quantity: 1 }];
    var f = frameVariant();
    if (f) {
      items.push({ id: f.id, quantity: 1, properties: {
        '_frame_for': D.productTitle, '_size': st.size } });
    }
    var pv = st.paper === 'premium' ? paperVariant() : null;
    if (pv) {
      items.push({ id: pv.id, quantity: 1, properties: {
        '_paper_quality': D.paperTitle, '_for_product': D.productTitle, '_size': st.size } });
    }
    var idle = els.atc.dataset.idle;
    btn.disabled = true; setTxt(els.atc.dataset.busy);
    fetch(ADD_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      setTxt(els.atc.dataset.done);
      return refreshCount();
    }).then(function () {
      window.setTimeout(function () { btn.disabled = false; setTxt(idle); }, 2400);
    }).catch(function () {
      btn.disabled = false; setTxt(idle);
      els.form.submit();
    });
  }

  /* ---- billedvæg: samme localStorage-kontrakt som temaets egen knap ---- */
  function addToWall() {
    var key = 'plf_wall_queue';
    var q = [];
    try { q = JSON.parse(localStorage.getItem(key) || '[]') || []; } catch (e) { q = []; }
    var h = els.wall.dataset.productHandle;
    if (h && q.indexOf(h) === -1) q.push(h);
    try { localStorage.setItem(key, JSON.stringify(q)); } catch (e) {}
    var old = els.wall.textContent;
    els.wall.textContent = '✓ ' + old + ' (' + q.length + ')';
    window.setTimeout(function () { els.wall.textContent = old; }, 2200);
  }

  /* ---- sticky-bar: glider op så snart den rigtige købsknap er ude af syne,
         og ned igen når den kommer til syne. rootMargin trækker bunden ind, så
         baren ikke blinker netop som knappen rører kanten. ---- */
  function stickyWatch() {
    if (!('IntersectionObserver' in window)) {
      els.sticky.dataset.shown = 'true';
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        els.sticky.dataset.shown = String(!e.isIntersecting);
      });
    }, { threshold: 0, rootMargin: '0px 0px -84px 0px' });
    io.observe(els.atc);
  }

  /* ---- bind ---- */
  root.querySelector('[data-plf-prev]').addEventListener('click', function () { nav(-1); });
  root.querySelector('[data-plf-next]').addEventListener('click', function () { nav(1); });
  root.querySelectorAll('[data-plf-unit]').forEach(function (b) {
    b.addEventListener('click', function () {
      st.unit = b.dataset.plfUnit;
      root.querySelectorAll('[data-plf-unit]').forEach(function (x) {
        x.setAttribute('aria-pressed', String(x === b));
      });
      render();
    });
  });
  els.form.addEventListener('submit', function (ev) {
    if (!window.fetch) return;
    ev.preventDefault();
    addToCart(els.atc, function (t) { els.atcTxt.textContent = t; });
  });
  els.stickyAtc.addEventListener('click', function () {
    addToCart(els.stickyAtc, function (t) { els.stickyAtc.textContent = t; });
  });
  els.wall.addEventListener('click', addToWall);
  root.querySelectorAll('[data-plf-paper-kind]').forEach(function (b) {
    b.addEventListener('click', function () { st.paper = b.dataset.plfPaperKind; render(); });
  });

  /* AR: samme app som temaets ar-poster-button — "se den i dit eget hjem",
     ikke billedvægbyggeren. */
  /* Designet bæres MED i URL'en (lz-string), præcis som væg-appens QR-links:
     {w: vægfarve, p:[{i,u,x,y,w,h,t,s}]} -> "u-<komprimeret>".
     x/y/w/h er designer-PIXELS; appen udleder skalaen af `s` ("50x70" i cm) via
     pxPerCm = w_px / bredde_cm. Vi bruger 4 px/cm og hænger plakaten i
     øjenhøjde (midten 150 cm) ca. 70 cm inde på væggen. */
  var AR_PX_PER_CM = 4;
  var AR_OAK = (function () {
    for (var i = 0; i < D.frames.length; i++) {
      if (D.frames[i].alt === 'Oak Nature') return i;
    }
    return -1;
  })();
  function arDesign() {
    var d = dims(st.size) || { w: 50, h: 70 };
    /* AR viser plakaten I RAMME — eg natur når kunden ikke selv har valgt en,
       præcis som galleriet åbner. Det er kun en VISNING: prisen og kurven
       følger stadig st.frame, så en uvalgt ramme koster ikke noget.
       Væg-appen beskærer selv rammemockups (FRAME_CROP). */
    var f = D.frames[st.frame];
    if ((!f || f.bare) && AR_OAK >= 0) f = D.frames[AR_OAK];
    if (!f) f = D.frames[0];
    var img = (f && f.u) || D.artBig || D.art;
    if (!img) return null;
    return {
      w: '',
      p: [{
        i: String(D.ar.pid),
        u: String(img).split('?')[0],
        x: Math.round(70 * AR_PX_PER_CM),
        y: Math.round((150 - d.h / 2) * AR_PX_PER_CM),
        w: Math.round(d.w * AR_PX_PER_CM),
        h: Math.round(d.h * AR_PX_PER_CM),
        t: (D.i18n && D.i18n.productTitle) || '',
        s: d.w + 'x' + d.h
      }]
    };
  }
  /* Størrelseschips i modalen. AR-appen kender ikke produktets varianter —
     designet kommer fra URL'en — så vælgeren bor her, og et klik skifter
     samtidig størrelsen i købsboksen. Iframen genindlæses, hvilket nulstiller
     et igangværende kamera; derfor ligger chipsene nederst, hvor de ikke
     rammes ved et uheld. */
  function buildArSizes() {
    var wrap = root.querySelector('[data-plf-ar-sizes]');
    if (!wrap) return;
    wrap.innerHTML = '';
    sizesFor(st.type).forEach(function (v) {
      var b = document.createElement('button');
      b.type = 'button';
      b.textContent = sizeLabel(v.s);
      b.setAttribute('aria-pressed', String(v.s === st.size));
      if (!v.a) b.disabled = true;
      b.addEventListener('click', function () {
        if (!v.a || v.s === st.size) return;
        st.size = v.s;
        render();                 /* pris, variant og galleri følger med */
        buildArSizes();
        pushArSize();
      });
      wrap.appendChild(b);
    });
  }
  function loadArFrame() {
    var a = D.ar, design = arDesign();
    if (!design || typeof LZString === 'undefined') return;
    var blob = 'u-' + LZString.compressToEncodedURIComponent(JSON.stringify(design));
    els.arFrame.src = a.base + '/ar/' + blob + '?locale=' + encodeURIComponent(a.loc);
  }
  /* Størrelsen sendes LIVE ind i AR-visningen. En genindlæsning ville slukke
     kameraet og tvinge kunden til at trykke "Start AR-kamera" igen — appen
     overskriver derfor bare målet på den plakat der allerede er tegnet.
     Kvitterer den ikke (gammel cachet udgave), falder vi tilbage til reload. */
  var arApplied = false;
  function sendArCommerce() {
    if (!els.arFrame || !els.arFrame.contentWindow) return;
    var sizes = sizesFor(st.type).map(function (v) {
      return {
        value: v.s,
        label: sizeLabel(v.s),
        price: v.m || money(v.p),
        available: !!v.a
      };
    });
    els.arFrame.contentWindow.postMessage({
      plfArCommerce: {
        posterId: String(D.ar.pid),
        title: (D.i18n && D.i18n.productTitle) || D.productTitle || '',
        selectedSize: st.size,
        price: els.atcPrice.textContent || '',
        sizes: sizes
      }
    }, '*');
  }
  function selectArSize(size) {
    var match = sizesFor(st.type).filter(function (v) { return v.a && v.s === String(size || ''); })[0];
    if (!match) return false;
    if (match.s !== st.size) {
      st.size = match.s;
      render();
      buildArSizes();
      pushArSize();
    }
    sendArCommerce();
    return true;
  }
  function returnToBuy() {
    var buy = root.querySelector('.plf-pdp__buy');
    if (buy && buy.scrollIntoView) window.setTimeout(function () {
      buy.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 30);
  }
  window.addEventListener('message', function (e) {
    if (!els.arFrame || e.source !== els.arFrame.contentWindow || !e.data) return;
    if (e.data.plfArApplied) arApplied = true;
    if (e.data.plfArRequestCommerce) sendArCommerce();
    if (e.data.plfArSelectSize) selectArSize(e.data.plfArSelectSize.size);
    if (e.data.plfArReturnToProduct || e.data.type === 'POSTERLEFI_CLOSE_AR') {
      closeAr();
      returnToBuy();
    }
    if (e.data.plfArAddToCart) {
      if (!selectArSize(e.data.plfArAddToCart.size)) return;
      closeAr();
      returnToBuy();
      addToCart(els.atc, function (text) { els.atcTxt.textContent = text; });
    }
  });
  function pushArSize() {
    var d = dims(st.size);
    if (!d || !els.arFrame || !els.arFrame.contentWindow) { loadArFrame(); return; }
    var payload = {};
    payload[String(D.ar.pid)] = d.w + 'x' + d.h;
    arApplied = false;
    try {
      els.arFrame.contentWindow.postMessage({ plfArSize: payload }, '*');
    } catch (err) { loadArFrame(); return; }
    window.setTimeout(function () { if (!arApplied) loadArFrame(); }, 900);
  }
  function openAr() {
    var a = D.ar, design = arDesign();
    if (!design || typeof LZString === 'undefined') return;
    var blob = 'u-' + LZString.compressToEncodedURIComponent(JSON.stringify(design));
    buildArSizes();
    /* FÆLDE: app'ens ar-viewer bruger selv useRoute("/ar/:designId"), så et
       locale-præfiks i stien ("/da-dk/ar/...") renderer siden UDEN designId og
       giver "Design ikke fundet". Sproget skal med som ?locale= — det sætter
       samtidig embed-mode, så appens egen sprogvælger skjules. */
    els.arFrame.src = a.base + '/ar/' + blob + '?locale=' + encodeURIComponent(a.loc);
    els.arModal.setAttribute('open', '');
    document.body.style.overflow = 'hidden';
  }
  var qrModulePromise = null;
  function isDesktopAr() {
    return !window.matchMedia || window.matchMedia('(min-width: 900px)').matches;
  }
  function arQrCopy() {
    var lang = String(document.documentElement.lang || 'en').toLowerCase().split('-')[0];
    var copy = {
      da: ['Scan med din telefon', 'Åbn kameraet på din telefon og scan QR-koden for at se plakaten på din væg.', 'Åbn på denne enhed'],
      en: ['Scan with your phone', 'Open the camera on your phone and scan the QR code to view the poster on your wall.', 'Open on this device'],
      de: ['Mit dem Handy scannen', 'Öffne die Kamera deines Handys und scanne den QR-Code, um das Poster an deiner Wand zu sehen.', 'Auf diesem Gerät öffnen'],
      sv: ['Skanna med mobilen', 'Öppna kameran på mobilen och skanna QR-koden för att se affischen på din vägg.', 'Öppna på den här enheten'],
      fi: ['Skannaa puhelimella', 'Avaa puhelimen kamera ja skannaa QR-koodi nähdäksesi julisteen seinälläsi.', 'Avaa tällä laitteella'],
      fr: ['Scannez avec votre téléphone', 'Ouvrez l’appareil photo de votre téléphone et scannez le code QR pour voir l’affiche sur votre mur.', 'Ouvrir sur cet appareil'],
      nl: ['Scan met je telefoon', 'Open de camera op je telefoon en scan de QR-code om de poster op je muur te bekijken.', 'Openen op dit apparaat'],
      it: ['Scansiona con il telefono', 'Apri la fotocamera del telefono e scansiona il codice QR per vedere il poster sulla parete.', 'Apri su questo dispositivo'],
      es: ['Escanea con tu teléfono', 'Abre la cámara del teléfono y escanea el código QR para ver el póster en tu pared.', 'Abrir en este dispositivo'],
      pl: ['Zeskanuj telefonem', 'Otwórz aparat w telefonie i zeskanuj kod QR, aby zobaczyć plakat na swojej ścianie.', 'Otwórz na tym urządzeniu']
    };
    return copy[lang] || copy.en;
  }
  function mobileProductArUrl() {
    var url = new URL(window.location.href);
    var v = current();
    url.hash = '';
    url.searchParams.delete('plf_ar');
    if (v && v.id) url.searchParams.set('variant', String(v.id));
    url.searchParams.set('plf_ar', '1');
    return url.toString();
  }
  function ensureArQrPanel() {
    var panel = root.querySelector('[data-plf-ar-qr]');
    if (panel) return panel;
    var box = root.querySelector('.plf-pdp__ar-box');
    if (!box) return null;
    var copy = arQrCopy();
    panel = document.createElement('div');
    panel.hidden = true;
    panel.setAttribute('data-plf-ar-qr', '');
    panel.style.cssText = 'flex:1 1 auto;min-height:0;padding:64px 34px 34px;display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;background:#fff;color:#17150f;';
    var title = document.createElement('h2');
    title.textContent = copy[0];
    title.style.cssText = 'margin:0 0 10px;font:600 28px/1.15 Newsreader,Georgia,serif;';
    var description = document.createElement('p');
    description.textContent = copy[1];
    description.style.cssText = 'max-width:380px;margin:0 0 24px;color:#615b50;font:400 15px/1.55 Archivo,Arial,sans-serif;';
    var code = document.createElement('div');
    code.setAttribute('data-plf-ar-qr-code', '');
    code.style.cssText = 'width:244px;height:244px;padding:12px;border:1px solid #e5dfd4;border-radius:14px;background:#fff;box-shadow:0 8px 28px rgba(23,21,15,.10);display:flex;align-items:center;justify-content:center;';
    var fallback = document.createElement('a');
    fallback.setAttribute('data-plf-ar-qr-link', '');
    fallback.textContent = copy[2];
    fallback.style.cssText = 'margin-top:22px;color:#17150f;text-decoration:underline;text-underline-offset:4px;font:600 14px/1.2 Archivo,Arial,sans-serif;';
    panel.appendChild(title);
    panel.appendChild(description);
    panel.appendChild(code);
    panel.appendChild(fallback);
    box.appendChild(panel);
    return panel;
  }
  function renderArQr(panel, url) {
    var code = panel.querySelector('[data-plf-ar-qr-code]');
    var fallback = panel.querySelector('[data-plf-ar-qr-link]');
    if (!code || !fallback) return;
    fallback.href = url;
    code.innerHTML = '';
    code.setAttribute('aria-label', 'QR code');
    if (!PLF_PDP_SCRIPT_SRC) return;
    var qrAsset = new URL('qr-code-generator.js', PLF_PDP_SCRIPT_SRC).href;
  render(); renderStage(); stickyWatch();
  if (!isDesktopAr() && new URLSearchParams(window.location.search).get('plf_ar') === '1') {
    window.setTimeout(openAr, 0);
  }
    /* Shopify minificerer ellers import(qrAsset) til require(qrAsset), som ikke
       findes i browseren. Funktionen konstrueres først ved runtime, så den
       indbyggede browser-import bevares; URL'en kommer kun fra vores eget
       versionsbestemte tema-asset. */
    qrModulePromise = qrModulePromise || (new Function('assetUrl', 'return import(assetUrl)'))(qrAsset);
    qrModulePromise.then(function (module) {
      code.innerHTML = '';
      new module.QRCode(code, { text: url, width: 220, height: 220, useSVG: true });
    }).catch(function () {
      code.textContent = 'QR';
    });
  }
  function openArQr() {
    var panel = ensureArQrPanel();
    if (!panel) return;
    els.arFrame.src = '';
    els.arFrame.style.display = 'none';
    var sizePanel = root.querySelector('[data-plf-ar-sizes]');
    if (sizePanel) sizePanel.style.display = 'none';
    panel.hidden = false;
    panel.style.display = 'flex';
    renderArQr(panel, mobileProductArUrl());
    els.arModal.setAttribute('open', '');
    document.body.style.overflow = 'hidden';
  }
  function openArForDevice() {
    if (isDesktopAr()) openArQr();
    else openAr();
  }
  function closeAr() {
    els.arModal.removeAttribute('open');
    els.arFrame.src = '';
    document.body.style.overflow = '';
  }
  root.querySelectorAll('[data-plf-ar]').forEach(function (b) { b.addEventListener('click', openArForDevice); });
  var arClose = root.querySelector('[data-plf-ar-close]');
  if (arClose) arClose.addEventListener('click', closeAr);
  els.arModal.addEventListener('click', function (e) { if (e.target === els.arModal) closeAr(); });

  var openGuide = root.querySelector('[data-plf-open-guide]');
  var closeGuide = root.querySelector('[data-plf-close-guide]');
  if (openGuide) openGuide.addEventListener('click', function () { els.guide.setAttribute('open', ''); });
  if (closeGuide) closeGuide.addEventListener('click', function () { els.guide.removeAttribute('open'); });
  els.guide.addEventListener('click', function (e) { if (e.target === els.guide) els.guide.removeAttribute('open'); });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    els.guide.removeAttribute('open');
    closeAr();
  });

  /* ---- start ---- */
  buildRail(); buildRooms(); buildTypes(); buildFrames(); syncFrameName();
  render(); renderStage(); stickyWatch();
  if (!isDesktopAr() && new URLSearchParams(window.location.search).get('plf_ar') === '1') {
    window.setTimeout(openAr, 0);
  }
})();
